import { render, staticRenderFns } from "./ajtb.vue?vue&type=template&id=5cef7c5a&scoped=true&"
import script from "./ajtb.vue?vue&type=script&lang=js&"
export * from "./ajtb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef7c5a",
  null
  
)

export default component.exports